import axios from "@/utils/axios";
import { GetRealmsResponse } from "@/api/game/get-realms.response";

export interface MythicKeystoneInfoResponse {
	zoneID: number;
	name: string;
	shortName: string;
}

export default {
	async fetchRealms(region = "eu"): Promise<GetRealmsResponse> {
		return (await axios().get(`/game/realms/?region=${region}`)).data;
	},
	async fetchMythicKeystones(): Promise<MythicKeystoneInfoResponse[]> {
		return (await axios().get("/game/keystones/")).data;
	}
};